
type Props = {
    type?: string,
    nameId: string,
    className: string;
    placeholder: string;
    value: string;
    autoComplete: "off" | undefined;
    maxLength?: number;
    minLength?: number;
    onChange: () => void;

  };


const FormInput = (props: Props) => {
  return (
    <input
        type={props.type}
        id={props.nameId}
        name={props.nameId}
        className={props.className}
        placeholder={props.placeholder}
        value={props.value}
        autoComplete={props.autoComplete}
        maxLength={props.maxLength}
        minLength={props.minLength}
        required
        onChange={props.onChange}
      />
  )
}

export default FormInput
